import { CATEGORY_SUBCATEGORY_API_URL } from "../utils/constants";
import axios from "axios";
import { isRecordActive } from "./activeRecordUtils";

// Combined API: replaces the separate grievance-category, department, and lending-partner APIs.

// Display labels for the "Grievance With" dropdown, keyed by the API's categoryCode.
const CATEGORY_LABELS = {
  LP: "State Channelising Agencies (SCAs)",
  DEPARTMENT: "NMDFC",
  LOAN: "Loan",
};

/**
 * Gets the combined category/subcategory data and formats it for the "Grievance With"
 * dropdown and the per-category Sub-Category dropdown.
 */
export const getCategorySubcategories = async () => {
  const response = await axios.get(CATEGORY_SUBCATEGORY_API_URL, {
    headers: {
      "ngrok-skip-browser-warning": "true",
    },
  });

  if (!response.data?.success) {
    throw new Error("Unable to load grievance categories.");
  }

  const records = (Array.isArray(response.data.data) ? response.data.data : []).filter(
    (record) => isRecordActive(record) && record?.name && record?.categoryId != null
  );

  // Builds one "Grievance With" option per distinct categoryId, ordered by categoryId.
  const categoriesById = new Map();
  records.forEach((record) => {
    const categoryId = String(record.categoryId);
    if (!categoriesById.has(categoryId)) {
      const code = String(record.categoryCode || "").toUpperCase();
      categoriesById.set(categoryId, {
        value: categoryId,
        label: CATEGORY_LABELS[code] || code || `Category ${categoryId}`,
        code: code.toLowerCase(),
      });
    }
  });
  const categories = Array.from(categoriesById.values()).sort(
    (a, b) => Number(a.value) - Number(b.value)
  );

  // Groups sub-category options by their parent categoryId for the Sub-Category dropdown.
  const subCategoriesByCategoryId = {};
  records.forEach((record) => {
    const categoryId = String(record.categoryId);
    if (!subCategoriesByCategoryId[categoryId]) {
      subCategoriesByCategoryId[categoryId] = [];
    }
    subCategoriesByCategoryId[categoryId].push({
      value: String(record.id),
      label: record.name,
    });
  });

  return { categories, subCategoriesByCategoryId };
};

/**
 * Returns a user-friendly error message for a failed category/subcategory request.
 */
export const getCategorySubcategoryErrorMessage = () => {
  // Never expose backend exception details (for example JDBC/database errors) to users.
  return "Unable to load grievance categories.";
};
